import { IObject } from 'types/common';
import { createActions } from 'redux-actions';

import { ActionTypes } from 'constants/index';

export const { playerUpdate } = createActions({
  [ActionTypes.PLAYER_UPDATE]: (payload: IObject): IObject => payload,
});
